import { dispatchSuccessWrap } from './genericActions'

import { actionTypes } from '../types'
import { constants } from '../../App.constants';
import moment from 'moment'

import axios from 'axios';

export const getMemberships = (cb) => {

    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        try {
            const payload = await axios.get(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/registration', headers)
            if (payload.data) {
                dispatchSuccessWrap(actionTypes.GET_MEMBERSHIPS, { resp: payload.data.data }, dispatch)
            }
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }
    }

}

export const getMembershipPhases = (loginToken, customerId, cb) => {

    return async () => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': loginToken
            }
        }

        try {
            const payload = await axios.get(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/stripe/customer/'+ customerId +'/subscription/schedule', headers)
            cb(payload?.data?.error, payload?.data?.data)

        } catch (error) {
            cb('error')
        }
    }
}

export const scheduleMembership = (loginToken, customerId, endBehavior, startDate, endDate, priceId, cb) => {

    return async () => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': loginToken
            }
        }

        const data = {
            endBehavior, startDate, endDate, priceId
        }

        try {
            const payload = await axios.post(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/stripe/customer/'+ customerId +'/subscription/schedule', data,  headers)
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }
    }
}

/**
 * Renewal for an EXPIRED member: a live subscription that starts now. The
 * server sets cancel_at (Dec 31) and the tax rate; only the price is sent.
 */
export const createRenewalSubscription = (loginToken, customerId, priceId, cb) => {

    return async () => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': loginToken
            }
        }

        try {
            const payload = await axios.post(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/stripe/customer/' + customerId + '/subscription/renewal', { priceId }, headers)
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }
    }
}

/**
 * The primary's answer to "Allow my add-ons to be billed on my subscription?".
 * The API takes the member from the login token, never from the request.
 */
export const setAddOnBillingAuthorization = (loginToken, paysForAddOns, cb) => {

    return async () => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': loginToken
            }
        }

        try {
            const payload = await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/memberFamily/addOnBillingAuthorization', { paysForAddOns: !!paysForAddOns }, headers)
            cb(payload.data.error, payload?.data?.data)

        } catch (error) {
            cb('error')
        }
    }
}

export const notifyOrganizer = (messageInfo, cb) => {
    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        const data = {
            messageInfo: messageInfo
        }

        try {
            const payload = await axios.post(constants.dashboardBaseUrl + '/notify/admins/tanglewood', data, headers)
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }
    }
}

export const welcomeUser = (messageInfo, templateId, cb) => {
    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        const data = {
            messageInfo,
            templateId
        }
        
        try {
            
            const payload = await axios.post(constants.dashboardBaseUrl + '/organization/'+ constants.selectedOrg +'/welcome', data, headers)
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }
    }
}

export const inviteUser = (messageInfo, templateId, cb) => {
    return async (dispatch) => {
        // The invite endpoint only accepts a signed-in member of the org
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        const data = {
            messageInfo: messageInfo,
            templateId: templateId
        }
        console.log(data)
        try {
            
            const payload = await axios.post(constants.dashboardBaseUrl + '/organization/'+ constants.selectedOrg +'/invite/add-on', data, headers)
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }
    }
}

export const subscribe = (loginToken, regId, token, paymentType, contractTerm, cb) => {

    return async (dispatch) => {

        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': loginToken
            }
        }
        let termsDate = moment().format('llll');
        var data = {
            stripeToken: token,
            paymentType: paymentType,
            contractTerm: contractTerm,
            termsAndConditionsAgreedOn: termsDate
            // No end date: memberships are open-ended (specs/open-ended-memberships).
        }
        if (token) {
            data.recurringPayTermsAgreedOn = termsDate
        }

        try {
            const payload = await axios.post(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/registration/' + regId + '/subscribe', data, headers)

            dispatchSuccessWrap(actionTypes.SUBSCRIBE, { resp: payload }, dispatch)
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }

    }

}

export const deleteACHDiscount = (subscriptionId, cb) => {

    return async (dispatch) => {

        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        try {
            const payload = await axios.delete(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/subscription/' + subscriptionId + '/achdiscount', headers)

            dispatchSuccessWrap(actionTypes.DELETE_DISCOUNT, { resp: payload }, dispatch)
            cb(null, payload)

        } catch (error) {
            cb('error')
        }

    }

}


export const addACHDiscount = (subscriptionId, cb) => {

    return async (dispatch) => {

        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        try {
            const payload = await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/subscription/' + subscriptionId + '/achdiscount', {}, headers)

            dispatchSuccessWrap(actionTypes.ADD_DISCOUNT, { resp: payload }, dispatch)
            cb(null, payload)

        } catch (error) {
            cb('error')
        }

    }

}



export const subscribeWithBankToken = (loginToken, regId, token, paymentType, contractTerm, cb) => {

    return async (dispatch) => {

        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': loginToken
            }
        }
        let termsDate = moment().format('llll');
        const data = {
            stripeToken: { id: token, tokenType: 'bank' },
            paymentType: paymentType,
            contractTerm: contractTerm,
            termsAndConditionsAgreedOn: termsDate,
            recurringPayTermsAgreedOn: termsDate
            // No end date: memberships are open-ended (specs/open-ended-memberships).
        }

        try {
            const payload = await axios.post(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/registration/' + regId + '/subscribe', data, headers)

            dispatchSuccessWrap(actionTypes.SUBSCRIBE, { resp: payload }, dispatch)
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }

    }

}

export const getQuestions = (regId, cb) => {

    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        try {
            const payload = await axios.get(constants.dashboardBaseUrl + '/registration/' + regId + '/questions', headers)
            if (payload.data) {
                dispatchSuccessWrap(actionTypes.GET_QUESTIONS, { resp: payload.data.data }, dispatch)
            }
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }
    }

}

export const nonMemberAdd = (loginToken, email, name, cb) => {
    return async (dispatch) => {

        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': loginToken
            }
        }

        const data = {
            email: email,
            name: name
        }

        try {
            const payload = await axios.post(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/nonMember', data, headers)

            dispatchSuccessWrap(actionTypes.NON_MEMBER_ADD, { resp: payload }, dispatch)
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }
    }
}

export const saveAnswers = (loginToken, regId, quesId, answer, cb) => {
    return async (dispatch) => {

        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': loginToken
            }
        }

        const data = {
            answer: answer
        }

        try {
            const payload = await axios.post(constants.dashboardBaseUrl + '/registration/' + regId + '/question/' + quesId + '/answer', data, headers)

            dispatchSuccessWrap(actionTypes.SAVE_ANSWERS, { resp: payload }, dispatch)
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }
    }
}

export const addMember = (loginToken, userId, cb) => {
    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': loginToken
            }
        }

        try {
            const payload = await axios.post(constants.apiUrl + '/organizations/' + constants.selectedOrg + '/users/' + userId, {}, headers)

            dispatchSuccessWrap(actionTypes.ADD_MEMBER, { resp: payload }, dispatch)
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }
    }
}
export const saveRegistrationInfo = (regId, cb) => {
    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        try {
            const payload = await axios.post(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/registration/' + regId + '/regInfo', {}, headers)

            dispatchSuccessWrap(actionTypes.SAVE_REG_INFO, { resp: payload }, dispatch)
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }
    }
}


export const addAllcalMemberToCalendarWithDashboardRole = (loginToken, calId, roleId, cb) => {

    return async (dispatch) => {

        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': loginToken
            }
        }

        try {
            const responseFromDashboardDB = await axios.get(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/role/' + roleId, headers)

            const data = {
                permissions: responseFromDashboardDB.data.data.rolePermissions,
                role: {
                    "name": responseFromDashboardDB.data.data.roleName,
                    "roleId": responseFromDashboardDB.data.data._id
                }
            }
            const payload = await axios.post(constants.apiUrl + '/organizations/' + constants.selectedOrg + '/calendars/' + calId + '/follow', data, headers)


            dispatchSuccessWrap(actionTypes.ADD_ROLE, { resp: payload }, dispatch)
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }

    }

}

export const getMemberInvites = (email, cb) => {

    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        try {
            const payload = await axios.get(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/invite/log?primaryMemberEmail='+ encodeURIComponent(email), headers)
           
            cb(payload.data.error, payload?.data?.data)

        } catch (error) {
            cb('error')
        }
    }

}

/**
 * The add-on family for the logged-in member, from the addOns collection.
 *
 * Takes no email: the API resolves identity from the login token, so a caller
 * can only ever read their own family. Replaces getMemberInvites, which asked
 * for a primaryMemberEmail and returned invite-log rows rather than members.
 */
export const getMemberFamily = (cb) => {

    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        try {
            const payload = await axios.get(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/memberFamily', headers)

            cb(payload.data.error, payload?.data?.data)

        } catch (error) {
            cb('error')
        }
    }

}

/**
 * Flow A of the add-on renewal: the primary's Renew/Resend on an accepted
 * add-on row. POST /organization/:orgId/addOn/:addOnId/renewal/send.
 *
 * The email always goes out; authorizePrimary records whether the primary
 * agreed to carry this add-on's plan on their own subscription.
 *
 * cb(false, { renewalId, status, entryLink, created, sent }) on success, or
 * cb({ status, message }) on failure. status is the HTTP status (409 with
 * "Renew your membership first" when the primary has not renewed yet), or
 * null when the request never got a response.
 */
export const sendAddOnRenewal = (addOnId, authorizePrimary, cb) => {

    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        try {
            // true / false sets who pays for this add-on; undefined is a plain
            // resend that keeps the add-on's setting.
            const body = typeof authorizePrimary === 'boolean' ? { authorizePrimary } : {}
            const payload = await axios.post(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/addOn/' + encodeURIComponent(addOnId) + '/renewal/send', body, headers)

            if (payload?.data?.error) {
                cb({ status: payload.status || null, code: payload.data.code || null, message: payload.data.message || null })
                return
            }
            cb(false, payload?.data?.data)

        } catch (error) {
            cb({ status: error?.response?.status || null, code: error?.response?.data?.code || null, message: error?.response?.data?.message || null })
        }
    }
}

export const logInvitedMember = (primaryMemberEmail, invitedMemberEmail, membershipType, registrationId, status, cb) => {

    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        const data = {
            invitedMemberEmail,
            primaryMemberEmail,
            membershipType,
            registrationId,
            status
        }

        try {
            const payload = await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/invite/log', data, headers)
           
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }
    }

}

export const getRegistrationCalendarAndAssociatedRole = (regId, cb) => {

    return async (dispatch) => {

        const headers = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        try {
            const payload = await axios.get(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/registration/' + regId + "/calendar", headers)
            if (payload.data) {
                dispatchSuccessWrap(actionTypes.GET_REG_CALENDARS, { resp: payload.data.data }, dispatch)
            }
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }

    }
}
// The primary corrects an add-on's email (add-ons without an online account
// only); the renewal email is re-sent to it. cb(err, { email, resent }).
export const updateAddOnEmail = (addOnId, email, cb) => {

    return async () => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }
        try {
            const payload = await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/addOn/' + encodeURIComponent(addOnId) + '/email', { email }, headers)
            if (payload?.data?.error) {
                cb({ status: payload.status || null, code: payload.data.code || null, message: payload.data.message || null })
                return
            }
            cb(false, payload?.data?.data)
        } catch (error) {
            cb({ status: error?.response?.status || null, code: error?.response?.data?.code || null, message: error?.response?.data?.message || null })
        }
    }
}
